import { DataBean } from "../DataBean";

export class DodoDocs extends DataBean {

    public async getFormData(formCode: string, camp: string, value: string, operator: string): Promise<any> {
        return this.getCustomService("CacheOptions", "com.advantage.shared.DataBean_getFormData_String_String_String_String", [formCode, camp, value, operator]);
    }

    public async getDirectoryList(formCode: string): Promise<any> {
        return this.getCustomService("CacheOptions", "com.advantage.shared.DataBean_getDirectoryList_String", [formCode]);
    }
    public async getFormInputs(formCode: string): Promise<any> {
        return this.getCustomService("CacheOptions", "com.advantage.shared.DataBean_getFormInputs_String", [formCode]);
    }
    public async getRenderFormInputs(formCode: string): Promise<any> {
        return this.getCustomService("CacheOptions", "com.advantage.shared.DataBean_getRenderFormInputs_String", [formCode]);
    }
    public async formInsertDodo(OperationUser: string,FormCode:string,Office:string,dataForm:any): Promise<any> {
        return this.getCustomService("CacheOptions", "com.advantage.shared.DataBean_formInsertDodo_String_String_String_java.util.List",
             [OperationUser,FormCode,Office,dataForm]);
    }

    public async formAttachFiles(OperationUser: string, BarCode: string,filesList:any): Promise<any> {
        return this.getCustomService("CacheOptions", "com.advantage.shared.DataBean_formAttachFiles_String_String_java.util.List", 
            [OperationUser,BarCode,filesList]);
    }
    public async getFiledListByDirectory(barCode: string, directory: string): Promise<any> {
        return this.getCustomService("CacheOptions", "com.advantage.shared.DataBean_getFiledListByDirectory_String_String", [barCode, directory]);
    }

    public async formGetBase64StringFile(FileCode: string): Promise<any> {
        return this.getCustomService("CacheOptions", "com.advantage.shared.DataBean_formGetBase64StringFile_String", [FileCode]);
    }
}